// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
import React from "react";
import { View, Text, TouchableOpacity, StyleSheet } from "react-native";
import colors from "../../../../config/colors";
import fonts from "../../../../config/fonts";
const FilterButtons = ({ selectedFilter, onPressFilter, getTranslation }) => {
  const filters = [
    getTranslation("Clienti"),
    "Auto",
    getTranslation("Manuali"),
  ];
  return (
    <View style={styles.filterContainer}>
      {filters.map((filter) => (
        <TouchableOpacity
          key={filter}
          style={[
            styles.filterButton,
            selectedFilter === filter && styles.selectedFilterButton,
          ]}
          onPress={() => onPressFilter(filter)}
        >
          <Text
            style={[
              styles.filterButtonText,
              selectedFilter === filter && styles.selectedFilterButtonText,
            ]}
          >
            {getTranslation(filter.charAt(0).toUpperCase() + filter.slice(1))}
          </Text>
        </TouchableOpacity>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.green,
  },
  itemContainer: {
    flexDirection: "row",
    alignItems: "center",
    padding: 6,
    marginVertical: 4,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: "green",
    position: "relative",
  },
  leftContent: {
    alignItems: "center",
    marginRight: 14,
  },
  description: {
    flex: 1,
    fontSize: 18,
    textAlign: "center",
    fontWeight: "bold",
    fontFamily: fonts.regular,
  },
  category: {
    fontSize: 16,
    fontFamily: fonts.regular,
    color: "gray",
  },
  urgentLabel: {
    position: "absolute",
    top: -70,
    left: 3,
    backgroundColor: "red",
    paddingHorizontal: 2,
    paddingVertical: 1,
    borderRadius: 5,
    zIndex: 1,
  },
  urgentText: {
    color: "white",
    fontWeight: "bold",
    fontFamily: fonts.regular,
  },
  addButton: {
    borderRadius: 20,
    padding: 10,
  },
  phoneButton: {
    borderRadius: 20,
    padding: 10,
  },
  filterContainer: {
    flexDirection: "row",
    justifyContent: "space-around",
    paddingVertical: 10,
    backgroundColor: colors.green,
    borderBottomWidth: 1,
    borderBottomColor: "gray",
  },
  filterButton: {
    paddingHorizontal: 20,
    paddingVertical: 10,
    borderWidth: 1,
    borderColor: "gray",
    borderRadius: 20,
    backgroundColor: "white",
  },
  selectedFilterButton: {
    backgroundColor: "green",
    borderColor: "darkgreen",
  },
  filterButtonText: {
    fontSize: 16,
    fontWeight: "bold",
    color: "black",
    fontFamily: fonts.regular,
  },
  selectedFilterButtonText: {
    color: "white",
    fontFamily: fonts.regular,
  },
  tripsLabel: {
    position: "absolute",
    top: 11,
    right: 70,
    width: 30,
    height: 30,
    backgroundColor: colors.green,
    borderRadius: 20,
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1,
  },
  tripsText: {
    color: "white",
    fontWeight: "bold",
    fontFamily: fonts.regular,
  },
  listContent: {
    paddingBottom: 20,
    marginTop: 5,
  },
});
export default FilterButtons;
